import { LEAD_LIST_SOURCE } from "../constants/lead-list-constants"

const {
  LINKEDIN_SEARCH_RESULT,
  SALES_NAVIGATOR_SEARCH_RESULT,
  SALES_NAVIGATOR_LIST,
  LINKEDIN_POST,
  RECRUITER_SEARCH_RESULT,
  RECRUITER_PIPELINE,
} = LEAD_LIST_SOURCE

export const decodeFilterURI = queryStringData => {
  return decodeURI(queryStringData)
    .replaceAll(" ", "%2520")
    .replaceAll("%2B", "%252B")
    .replaceAll("%20", "%2520")
    .replaceAll("%C5", "%25C5")
    .replaceAll("%25C5%8", "%25C5%258")
    .replaceAll("%22%2520", "%2522%2520")
    .replaceAll("%22", "%2522")
    .replaceAll("%29", "%2529")
    .replaceAll("%28", "%2528")
    .replaceAll("%22", "%2522")
    .replaceAll("'", "%2527")
    .replaceAll("%C3%", "%25C3%25")
    .replaceAll("%2C%2520", "$252C%2520")
    .replaceAll("%26", "%2526")
    .replaceAll("%27", "%2527")
    .replaceAll("%E2", "%25E22")
    .replaceAll("%80", "%2580")
    .replaceAll("%8B", "%258B")
    .replaceAll("%24252C%2520", "%252C%2520")
    .replaceAll("$252C", "%252C")
    .replaceAll("%25E22", "%25E2")
}

export const isNewSalesNavLink = url => {
  return /,NAME_SEARCH|,COMPANY_SEARCH/.test(url) || /[a-zA-Z0-9+_-]{20,}/.test(url)
}

export const isValidLinkedInUrl = url => {
  try {
    const parsedUrl = new URL(url)
    const host = parsedUrl.hostname.replace("www.", "")
    const path = parsedUrl.pathname

    const validHost = ["linkedin.com", "salesnavigator.linkedin.com"].includes(host)

    // LinkedIn or Sales Navigator must be host
    if (!validHost) {
      return false
    }

    // LinkedIn people search
    if (path.startsWith("/search/results/people")) {
      return true
    }

    // LinkedIn post
    if (path.startsWith("/feed/update/") || path.startsWith("/posts/")) {
      return true
    }

    // Sales Navigator people search
    if (path.startsWith("/sales/search/people")) {
      return true
    }

    // Sales Navigator lead list
    if (path.startsWith("/sales/lists/")) {
      return true
    }

    // LinkedIn Recruiter project list
    if (path.startsWith("/recruiter/project")) {
      return true
    }

    return false
  } catch (e) {
    return false
  }
}

export const recognizedLeadListTypeFromUrl = sourceUrl => {
  let listType = ""
  if (sourceUrl.includes("linkedin.com/search")) {
    listType = LINKEDIN_SEARCH_RESULT
  }
  if (sourceUrl.includes("linkedin.com/sales")) {
    listType = SALES_NAVIGATOR_SEARCH_RESULT
  }
  if (sourceUrl.includes("linkedin.com/sales/lists/people")) {
    listType = SALES_NAVIGATOR_LIST
  }
  if (sourceUrl.includes("linkedin.com/posts")) {
    listType = LINKEDIN_POST
  }
  if (sourceUrl.includes("linkedin.com/talent/search")) {
    listType = RECRUITER_SEARCH_RESULT
  }
  if (sourceUrl.includes("linkedin.com/talent/hire")) {
    listType = RECRUITER_PIPELINE
  }
  return listType
}
